<template>
	<div>
		<!-- 添加/修改 -->
		<el-dialog :title="title" :visible.sync="dialogVisible" width="800px" :close-on-click-modal="false" :before-close="handleClose">
			<el-form :inline="false" :model="addOrUpdateForm" :rules="rules" ref="addOrUpdateForm" label-width="140px">
				<el-form-item label="触发器名称" prop="title"><el-input type="text" v-model="addOrUpdateForm.title"></el-input></el-form-item>
				<el-form-item label="触发器类型" prop="type">
					<el-select v-model="addOrUpdateForm.type" placeholder="请选择触发器类型">
						<el-option label="设备" value="device"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="选择模版和变量" prop="variableId">
					<el-select v-model="addOrUpdateForm.templateId" filterable remote reserve-keyword placeholder="请选择模版" :remote-method="queryTemplateList"
						:loading="templateLoading" @focus="templateSelectFocus" :clearable="true" @change="templateChange">
						<el-option v-for="item in templateList" :key="item.id" :label="item.title" :value="item.id">
						</el-option>
					</el-select>
					<el-select v-model="addOrUpdateForm.variableId" filterable remote reserve-keyword placeholder="请选择变量" :remote-method="queryTemplateVariableList"
						:loading="templateVariableLoading" @focus="templateVariableSelectFocus" :clearable="true" @change="templateVariableChange">
						<el-option v-for="item in templateVariableList" :key="item.id" :label="item.title" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="触发条件" prop="triggerCondition">
					<el-select v-model="addOrUpdateForm.triggerCondition" placeholder="请选择触发条件">
						<el-option label="开关OFF" value="开关OFF"></el-option>
						<el-option label="开关ON" value="开关ON"></el-option>
						<el-option label="数值小于A" value="数值小于A"></el-option>
						<el-option label="数值大于B" value="数值大于B"></el-option>
						<el-option label="数值大于A且小于B" value="数值大于A且小于B"></el-option>
						<el-option label="数值小于A且大于B" value="数值小于A且大于B"></el-option>
						<el-option label="数值等于A" value="数值等于A"></el-option>
					</el-select>
					<el-input-number type="number" v-model="addOrUpdateForm.a" :controls="false" :min="1" :clearable="true"
						v-if="addOrUpdateForm.triggerCondition!=null&&addOrUpdateForm.triggerCondition.includes('A')" placeholder="请输入A值"></el-input-number>
					<el-input-number type="number" v-model="addOrUpdateForm.b" :controls="false" :min="1" :clearable="true"
						v-if="addOrUpdateForm.triggerCondition!=null&&addOrUpdateForm.triggerCondition.includes('B')" placeholder="请输入A值"></el-input-number>
				</el-form-item>
				<el-form-item label="报警" prop="openAlarm">
					<el-switch v-model="addOrUpdateForm.openAlarm">
					</el-switch>
				</el-form-item>
				<el-form-item label="报警内容" prop="alarmMessage" v-if="addOrUpdateForm.openAlarm">
					<el-input type="textarea" :autosize="{ minRows: 3}" v-model="addOrUpdateForm.alarmMessage"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="small" @click="handleClose">取 消</el-button>
				<el-button size="small" type="primary" @click="handleUpdate">确 定</el-button>
			</div>
		</el-dialog>

	</div>
</template>
<script>
	export default {
		name: 'templateTriggerAdd',
		props: ['dialogVisible', 'addOrUpdateForm', 'title'],
		watch: {
			dialogVisible(newVal) {
				if (newVal) {
					if (this.$refs.addOrUpdateForm != undefined) {
						this.$refs['addOrUpdateForm'].resetFields();
					}
					if (!this.addOrUpdateForm.id) {
						this.addOrUpdateForm.type = "device";
						this.addOrUpdateForm.openAlarm=false;
					}
					this.templateList = [{
						id: this.addOrUpdateForm.templateId,
						title: this.addOrUpdateForm.templateTitle,
					}]
					this.templateVariableList = [{
						id: this.addOrUpdateForm.variableId,
						title: this.addOrUpdateForm.variableTitle,
					}]
				}
			}
		},
		data() {
			return {
				dialogTemplateVisible: false,
				templateList: [],
				templateLoading: false,
				queryTemplateVariableParams: {
					currentPage: 1,
					pageSize: 3000,
					defaultSort: {}
				},
				dialogTemplateVariableVisible: false,
				templateVariableList: [],
				templateVariableLoading: false,
				queryTemplateParams: {
					currentPage: 1,
					pageSize: 999,
					defaultSort: {
						order: 'desc',
						prop: 'id'
					}
				},
				rules: {
					title: [{
							required: true,
							message: '请输入触发器名称',
							trigger: 'blur'
						},
						{
							max: 100,
							message: '长度最长支持100',
							trigger: 'blur'
						}
					],
					type: [{
						required: true,
						message: '请选择触发器类型',
						trigger: 'change'
					}],
					templateId: [{
						required: true,
						message: '请选择模版',
						trigger: 'blur'
					}],
					variableId: [{
						required: true,
						message: '请选择变量',
						trigger: 'blur'
					}],
					triggerCondition: [{
						required: true,
						message: '请选择触发条件',
						trigger: 'blur'
					}],
				}
			};
		},
		methods: {
			templateSelectFocus() {
				this.queryTemplateList()
			},
			templateChange() {
				this.addOrUpdateForm.variableId = null
			},
			templateVariableChange() {
				this.$forceUpdate(); // 强制重新渲染当前组件
			},
			queryTemplateList(query) {
				let that = this;
				this.templateLoading = true;
				this.queryTemplateParams.title = query;
				this.$http({
					method: 'POST',
					url: 'template/query',
					data: this.queryTemplateParams,
				}).then(function(res) {
					that.templateList = res.data.data;
					that.templateLoading = false
				})
			},
			templateVariableSelectFocus() {
				this.queryTemplateVariableList()
			},
			queryTemplateVariableList(query) {
				let that = this;
				this.queryTemplateVariableParams.title = query;
				if (this.addOrUpdateForm.templateId) {
					this.templateVariableLoading = true;
					this.queryTemplateVariableParams.templateId = this.addOrUpdateForm.templateId;
					this.$http({
						method: 'POST',
						url: 'template/variable/query',
						data: this.queryTemplateVariableParams,
					}).then(function(res) {
						that.templateVariableList = res.data.data;
						that.templateVariableLoading = false
					})
				} else {
					that.templateVariableList = []
					this.addOrUpdateForm.variableId = null
				}
			},
			handleClose() {
				this.$emit("update:dialogVisible", false);
			},
			handleUpdate() {
				//添加/保存
				this.$refs['addOrUpdateForm'].validate(valid => {
					if (valid) {
						let that = this;
						let url = '/create';
						if (that.addOrUpdateForm.id) {
							url = '/update';
						}
						this.$http({
								method: 'POST',
								url: '/template/trigger/' + url,
								data: that.addOrUpdateForm
							})
							.then(function(res) {
								if (res.data.errorCode == '0000') {
									if (that.addOrUpdateForm.id == null) {
										that.successMessage('添加成功', '您成功添加一条数据');
									} else {
										if (that.isOne) {
											that.successMessage('系统提示', '修改成功');
										} else {
											that.successMessage('编辑成功', '您成功编辑一条数据');
										}
									}
									that.handleClose();
									that.$emit('custom-event');
								}
							})
							.catch(function(error) {
								console.log(error);
							});
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			successMessage(title, msg) {
				//成功提示
				this.$notify({
					title: title,
					message: msg,
					type: 'success'
				});
			},
		},
		mounted: function() {

		}

	}
</script>


// WEBPACK FOOTER //
// src/components/layout/devices/templateTriggerAdd.vue